import { Helmet } from 'react-helmet'

interface SEOProps {
    title: string
    description: string
    canonical?: string
    ogType?: string
    ogImage?: string
    noindex?: boolean
    jsonLd?: object
}

const BASE_URL = 'https://barbermate.eu'
const DEFAULT_IMAGE = `${BASE_URL}/og-image.png`

export function SEO({ title, description, canonical, ogType = 'website', ogImage, noindex, jsonLd }: SEOProps) {
    const fullTitle = title.includes('BarberMate') ? title : `${title} | BarberMate`
    const canonicalUrl = canonical ? `${BASE_URL}${canonical}` : undefined
    const image = ogImage || DEFAULT_IMAGE

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            {noindex && <meta name="robots" content="noindex, nofollow" />}
            {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

            <meta property="og:type" content={ogType} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {jsonLd && (
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            )}
        </Helmet>
    )
}
